import thumb_1 from "../assets/TVCS_Video/video_1_files/Becoming-a-Father.5a8ae8e6.png";
import thumb_2 from "../assets/TVCS_Video/video_1_files/Birthday-Party-thumbnail.2d17eb0e.png";
import thumb_3 from "../assets/TVCS_Video/video_1_files/DIVIDE.07a3493d.png";
import thumb_4 from "../assets/TVCS_Video/video_1_files/Innovative-Friend.372ed62b.png";
import thumb_5 from "../assets/TVCS_Video/video_1_files/Airy-Updo.30a5b5ef.jpg";
import thumb_6 from "../assets/TVCS_Video/video_1_files/Cafe.55a67dbd.png";
import thumb_7 from "../assets/TVCS_Video/video_1_files/beti-film-70.550add3f.jpg";
import thumb_8 from "../assets/TVCS_Video/video_1_files/Daddy-No1.b7308bf5.png";
import TvcBanner from "../assets/TVCS_Video/Banners";
import { longFormatAssets } from "../assets/longformat";
import { shortsanddocAssets } from "../assets/shortsanddocumentaries";

export const data = {
  videos: [
    {
      id: "1",
      title: "Big Buck Bunny",
      thumbnailUrl:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Big_Buck_Bunny_thumbnail_vlc.png/1200px-Big_Buck_Bunny_thumbnail_vlc.png",
      duration: "8:18",
      uploadTime: "May 9, 2011",
      views: "24,969,123",
      author: "Vlc Media Player",
      videoUrl:
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
      description:
        "Big Buck Bunny tells the story of a giant rabbit with a heart bigger than himself. When one sunny day three rodents rudely harass him, something snaps... and the rabbit ain't no bunny anymore! In the typical cartoon tradition he prepares the nasty rodents a comical revenge.\n\nLicensed under the Creative Commons Attribution license\nhttp://https://www.bigbuckbunny.org",
      subscriber: "25254545 Subscribers",
      isLive: true,
    },
    {
      id: "2",
      title: "The first Blender Open Movie from 2006",
      thumbnailUrl:
        "https://i.ytimg.com/vi_webp/gWw23EYM9VM/maxresdefault.webp",
      duration: "12:18",
      uploadTime: "May 9, 2011",
      views: "24,969,123",
      author: "Blender Inc.",
      videoUrl:
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
      description:
        "Song : Raja Raja Kareja Mein Samaja\nAlbum : Raja Kareja Mein Samaja\nArtist : Radhe Shyam Rasia\nSinger : Radhe Shyam Rasia\nMusic Director : Sohan Lal, Dinesh Kumar\nLyricist : Vinay Bihari, Shailesh Sagar, Parmeshwar Premi\nMusic Label : T-Series",
      subscriber: "25254545 Subscribers",
      isLive: true,
    },
    {
      id: "3",
      title: "For Bigger Blazes",
      thumbnailUrl: "https://i.ytimg.com/vi/Dr9C2oswZfA/maxresdefault.jpg",
      duration: "8:18",
      uploadTime: "May 9, 2011",
      views: "24,969,123",
      author: "T-Series Regional",
      videoUrl:
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
      description:
        "Song : Raja Raja Kareja Mein Samaja\nAlbum : Raja Kareja Mein Samaja\nArtist : Radhe Shyam Rasia\nSinger : Radhe Shyam Rasia\nMusic Director : Sohan Lal, Dinesh Kumar\nLyricist : Vinay Bihari, Shailesh Sagar, Parmeshwar Premi\nMusic Label : T-Series",
      subscriber: "25254545 Subscribers",
      isLive: true,
    },
    {
      id: "4",
      title: "For Bigger Escape",
      thumbnailUrl:
        "https://img.jakpost.net/c/2019/09/03/2019_09_03_78912_1567484272._large.jpg",
      duration: "8:18",
      uploadTime: "May 9, 2011",
      views: "24,969,123",
      author: "T-Series Regional",
      videoUrl:
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
      description:
        "Introducing Chromecast. The easiest way to enjoy online video and music on your TV—for when Batman's escapes aren't quite big enough. For $35. Learn how to use Chromecast with Google Play Movies and more at google.com/chromecast.",
      subscriber: "25254545 Subscribers",
      isLive: false,
    },
    {
      id: "5",
      title: "Big Buck Bunny",
      thumbnailUrl:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Big_Buck_Bunny_thumbnail_vlc.png/1200px-Big_Buck_Bunny_thumbnail_vlc.png",
      duration: "8:18",
      uploadTime: "May 9, 2011",
      views: "24,969,123",
      author: "Vlc Media Player",
      videoUrl:
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
      description:
        "Big Buck Bunny tells the story of a giant rabbit with a heart bigger than himself. When one sunny day three rodents rudely harass him, something snaps... and the rabbit ain't no bunny anymore! In the typical cartoon tradition he prepares the nasty rodents a comical revenge.\n\nLicensed under the Creative Commons Attribution license\nhttp://https://www.bigbuckbunny.org",
      subscriber: "25254545 Subscribers",
      isLive: true,
    },
    {
      id: "6",
      title: "For Bigger Blazes",
      thumbnailUrl: "https://i.ytimg.com/vi/Dr9C2oswZfA/maxresdefault.jpg",
      duration: "8:18",
      uploadTime: "May 9, 2011",
      views: "24,969,123",
      author: "T-Series Regional",
      videoUrl:
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
      description:
        "Song : Raja Raja Kareja Mein Samaja\nAlbum : Raja Kareja Mein Samaja\nArtist : Radhe Shyam Rasia\nSinger : Radhe Shyam Rasia\nMusic Director : Sohan Lal, Dinesh Kumar\nLyricist : Vinay Bihari, Shailesh Sagar, Parmeshwar Premi\nMusic Label : T-Series",
      subscriber: "25254545 Subscribers",
      isLive: false,
    },
    {
      id: "7",
      title: "For Bigger Escape",
      thumbnailUrl:
        "https://img.jakpost.net/c/2019/09/03/2019_09_03_78912_1567484272._large.jpg",
      duration: "8:18",
      uploadTime: "May 9, 2011",
      views: "24,969,123",
      author: "T-Series Regional",
      videoUrl:
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
      description:
        "Introducing Chromecast. The easiest way to enjoy online video and music on your TV—for when Batman's escapes aren't quite big enough. For $35. Learn how to use Chromecast with Google Play Movies and more at google.com/chromecast.",
      subscriber: "25254545 Subscribers",
      isLive: true,
    },
    {
      id: "8",
      title: "The first Blender Open Movie from 2006",
      thumbnailUrl:
        "https://i.ytimg.com/vi_webp/gWw23EYM9VM/maxresdefault.webp",
      duration: "12:18",
      uploadTime: "May 9, 2011",
      views: "24,969,123",
      author: "Blender Inc.",
      videoUrl:
        "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
      description:
        "Song : Raja Raja Kareja Mein Samaja\nAlbum : Raja Kareja Mein Samaja\nArtist : Radhe Shyam Rasia\nSinger : Radhe Shyam Rasia\nMusic Director : Sohan Lal, Dinesh Kumar\nLyricist : Vinay Bihari, Shailesh Sagar, Parmeshwar Premi\nMusic Label : T-Series",
      subscriber: "25254545 Subscribers",
      isLive: false,
    },
  ],
  movies: [
    {
      adult: false,
      backdrop_path: "/yDHYTfA3R0jFYba16jBB1ef8oIt.jpg",
      genre_ids: [28, 35, 878],
      id: 533535,
      original_language: "en",
      original_title: "Deadpool & Wolverine",
      overview:
        "A listless Wade Wilson toils away in civilian life with his days as the morally flexible mercenary, Deadpool, behind him. But when his homeworld faces an existential threat, Wade must reluctantly suit-up again with an even more reluctant Wolverine.",
      popularity: 11646.745,
      poster_path: thumb_1,
      release_date: "2024-07-24",
      title: "Deadpool & Wolverine",
      video: false,
      vote_average: 7.872,
      vote_count: 1682,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/lgkPzcOSnTvjeMnuFzozRO5HHw1.jpg",
      genre_ids: [16, 10751, 35, 28],
      id: 519182,
      original_language: "en",
      original_title: "Despicable Me 4",
      overview:
        "Gru and Lucy and their girls—Margo, Edith and Agnes—welcome a new member to the Gru family, Gru Jr., who is intent on tormenting his dad. Gru also faces a new nemesis in Maxime Le Mal and his femme fatale girlfriend Valentina, forcing the family to go on the run.",
      popularity: 3315.933,
      poster_path: thumb_2,
      release_date: "2024-06-20",
      title: "Despicable Me 4",
      video: false,
      vote_average: 7.366,
      vote_count: 867,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/3q01ACG0MWm0DekhvkPFCXyPZSu.jpg",
      genre_ids: [28, 80, 53, 35],
      id: 573435,
      original_language: "en",
      original_title: "Bad Boys: Ride or Die",
      overview:
        "After their late former Captain is framed, Lowrey and Burnett try to clear his name, only to end up on the run themselves.",
      popularity: 3267.171,
      poster_path: thumb_3,
      release_date: "2024-06-05",
      title: "Bad Boys: Ride or Die",
      video: false,
      vote_average: 7.648,
      vote_count: 1465,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/stKGOm8UyhuLPR9sZLjs5AkmncA.jpg",
      genre_ids: [16, 10751, 12, 35],
      id: 1022789,
      original_language: "en",
      original_title: "Inside Out 2",
      overview:
        "Teenager Riley's mind headquarters is undergoing a sudden demolition to make room for something entirely unexpected: new Emotions! Joy, Sadness, Anger, Fear and Disgust, who’ve long been running a successful operation by all accounts, aren’t sure how to feel when Anxiety shows up. And it looks like she’s not alone.",
      popularity: 3068.889,
      poster_path: thumb_4,
      release_date: "2024-06-11",
      title: "Inside Out 2",
      video: false,
      vote_average: 7.627,
      vote_count: 2322,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/2RVcJbWFmICRDsVxRI8F5xRmRsK.jpg",
      genre_ids: [27, 878, 53],
      id: 762441,
      original_language: "en",
      original_title: "A Quiet Place: Day One",
      overview:
        "As New York City is invaded by alien creatures who hunt by sound, a woman named Sam fights to survive with her cat.",
      popularity: 2399.982,
      poster_path: thumb_5,
      release_date: "2024-06-26",
      title: "A Quiet Place: Day One",
      video: false,
      vote_average: 6.944,
      vote_count: 1193,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/5W1sQidR2a9e8O1vk2IDhzbT4W7.jpg",
      genre_ids: [28, 53],
      id: 1129598,
      original_language: "en",
      original_title: "Prey",
      overview:
        "A young couple is compelled to leave their Christian missionary station in the Kalahari Desert after being threatened with death by an extremist militant gang. After crashing their aircraft they must battle man and beast for their lives.",
      popularity: 1903.504,
      poster_path: thumb_6,
      release_date: "2024-03-15",
      title: "Prey",
      video: false,
      vote_average: 6.467,
      vote_count: 136,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/r7HV1rKdUus2gJNChswMtpjpPft.jpg",
      genre_ids: [16, 35, 12, 10751],
      id: 831815,
      original_language: "en",
      original_title: "Saving Bikini Bottom: The Sandy Cheeks Movie",
      overview:
        "When Bikini Bottom is scooped from the ocean, scientific squirrel Sandy Cheeks and her pal SpongeBob SquarePants saddle up for Texas to save their town.",
      popularity: 1821.087,
      poster_path: thumb_7,
      release_date: "2024-08-01",
      title: "Saving Bikini Bottom: The Sandy Cheeks Movie",
      video: false,
      vote_average: 6.358,
      vote_count: 109,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/tqSg1hHiSWhHAhnjDhhevaFGsP0.jpg",
      genre_ids: [28, 18],
      id: 1066262,
      original_language: "en",
      original_title: "The Convert",
      overview:
        "Munro, a soldier turned lay preacher, comes to New Zealand to minister to the first British colonists, but he is converted by the powerful chief Maianui to serve a different purpose.",
      popularity: 1346.01,
      poster_path: thumb_8,
      release_date: "2024-03-14",
      title: "The Convert",
      video: false,
      vote_average: 6.579,
      vote_count: 38,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/c3rwwFFVbkyEI6wPtpPd9lvovPW.jpg",
      genre_ids: [28, 36],
      id: 1311550,
      original_language: "en",
      original_title: "House of Ga'a",
      overview:
        "At the height of the Oyo Empire, the ferocious Bashorun Ga'a became more powerful than the kings he enthroned, only to be undone by his own blood.",
      popularity: 1233.972,
      poster_path: thumb_1,
      release_date: "2024-07-26",
      title: "House of Ga'a",
      video: false,
      vote_average: 5.964,
      vote_count: 28,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/1wP1phHo2CROOqzv7Azs0MT5esU.jpg",
      genre_ids: [16, 35, 10751, 12],
      id: 748783,
      original_language: "en",
      original_title: "The Garfield Movie",
      overview:
        "Garfield, the world-famous, Monday-hating, lasagna-loving indoor cat, is about to have a wild outdoor adventure! After an unexpected reunion with his long-lost father – scruffy street cat Vic – Garfield and his canine friend Odie are forced from their perfectly pampered life into joining Vic in a hilarious, high-stakes heist.",
      popularity: 1179.138,
      poster_path: thumb_2,
      release_date: "2024-04-30",
      title: "The Garfield Movie",
      video: false,
      vote_average: 7.216,
      vote_count: 719,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/fqv8v6AycXKsivp1T5yKtLbGXce.jpg",
      genre_ids: [878, 12, 28],
      id: 653346,
      original_language: "en",
      original_title: "Kingdom of the Planet of the Apes",
      overview:
        "Several generations following Caesar's reign, apes – now the dominant species – live harmoniously while humans have been reduced to living in the shadows. As a new tyrannical ape leader builds his empire, one young ape undertakes a harrowing journey that will cause him to question all he's known about the past and to make choices that will define a future for apes and humans alike.",
      popularity: 1022.387,
      poster_path: thumb_4,
      release_date: "2024-05-08",
      title: "Kingdom of the Planet of the Apes",
      video: false,
      vote_average: 7.174,
      vote_count: 2394,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/viKEEaaCaZ0hZ2nGuvIEozlLooL.jpg",
      genre_ids: [27, 80, 9648],
      id: 1023922,
      original_language: "en",
      original_title: "MaXXXine",
      overview:
        "In 1980s Hollywood, adult film star and aspiring actress Maxine Minx finally gets her big break. But as a mysterious killer stalks the starlets of Hollywood, a trail of blood threatens to reveal her sinister past.",
      popularity: 1005.912,
      poster_path: thumb_5,
      release_date: "2024-07-04",
      title: "MaXXXine",
      video: false,
      vote_average: 6.4,
      vote_count: 264,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
    {
      adult: false,
      backdrop_path: "/w22yUH5pAZ3CcTjbw9GEzPd5wxs.jpg",
      genre_ids: [878, 35],
      id: 1242372,
      original_language: "zh",
      original_title: "从21世纪安全撤离",
      overview:
        'On Planet K, unknown to anyone on Earth, three teenagers chosen by fate can travel back and forth twenty years into the future by sneezing. In the face of a shocking plot to destroy the world, they have nothing but crystal-clear stupidity and single-digit combat power, so how can they transform into heroes and fight against the super-villainous villains who are intent on destroying the world? How can they turn into heroes and fight against the super baddest villains intent on destroying the world? The "King Bomb" brothers, who look like grown-ups but have minds like no other, will save the future on behalf of the K-Star!',
      popularity: 985.428,
      poster_path: thumb_7,
      release_date: "2024-07-18",
      title: "Escape from the 21st Century",
      video: false,
      vote_average: 7.167,
      vote_count: 15,
      year: 2024,
      season: 1,
      number_of_languages: 2,
      rating: "PG-13",
      description:
        "A thrilling sci-fi comedy that keeps you on the edge of your seat.",
    },
  ],
};

export const tvcsVideosOld = [
  { id: 1, videoId: "OclaX8TXVcQ", thumbnail: TvcBanner.Banner1 },
  { id: 2, videoId: "cp-cP9B1iWk", thumbnail: TvcBanner.Banner2 },
  { id: 3, videoId: "T3AtRfn-WJw", thumbnail: TvcBanner.Banner3 },
  { id: 4, videoId: "L9NZLtfHB18", thumbnail: TvcBanner.Banner4 },
  { id: 5, videoId: "xSffu54_bXQ", thumbnail: TvcBanner.Banner5 },
  { id: 6, videoId: "PlBeYwFOfU4", thumbnail: TvcBanner.Banner6 },
  { id: 7, videoId: "4y5UR9fAouQ", thumbnail: TvcBanner.Banner7 },
  { id: 8, videoId: "reNzcH9rPns", thumbnail: TvcBanner.Banner8 },
  { id: 9, videoId: "5dOTI9LG1T0", thumbnail: TvcBanner.Banner9 },
  { id: 10, videoId: "ecKXwq5Mik4", thumbnail: TvcBanner.Banner10 },
  { id: 11, videoId: "Qs0_Eg6qx8g", thumbnail: TvcBanner.Banner11 },
  { id: 12, videoId: "jGKwJV1ZIWs", thumbnail: TvcBanner.Banner12 },
  { id: 13, videoId: "0egglPxUFXE", thumbnail: TvcBanner.Banner13 },
  { id: 14, videoId: "3emrVSFlABY", thumbnail: TvcBanner.Banner14 },
  { id: 15, videoId: "Ik-7m-UfKRc", thumbnail: TvcBanner.Banner15 },
  { id: 16, videoId: "yHW7axdVhFk", thumbnail: TvcBanner.Banner16 },
  { id: 17, videoId: "i4eC0TQ6jLU", thumbnail: TvcBanner.Banner17 },
  { id: 18, videoId: "dlil1p3xOrc", thumbnail: TvcBanner.Banner18 },
  { id: 19, videoId: "cGdF6ao0Pso", thumbnail: TvcBanner.Banner19 },
  { id: 20, videoId: "h36hReRlqzU", thumbnail: TvcBanner.Banner20 },
  { id: 21, videoId: "TdrWlXvLhXo", thumbnail: TvcBanner.Banner21 },
  { id: 22, videoId: "o6c5AkWvge8", thumbnail: TvcBanner.Banner22 },
  { id: 23, videoId: "Z05C3YiR20s", thumbnail: TvcBanner.Banner23 },
  { id: 24, videoId: "BcfpoyjkZwo", thumbnail: TvcBanner.Banner24 },
  { id: 25, videoId: "BgSKH-aQAiU", thumbnail: TvcBanner.Banner25 },
  { id: 26, videoId: "qZ9tbwfejWg", thumbnail: TvcBanner.Banner26 },
  { id: 27, videoId: "IxuJWWfoZ7I", thumbnail: TvcBanner.Banner27 },
  { id: 28, videoId: "dQbSwtMSIcc", thumbnail: TvcBanner.Banner28 },
  { id: 29, videoId: "CHGng6slutY", thumbnail: TvcBanner.Banner29 },
  { id: 30, videoId: "RctSQI5WqzI", thumbnail: TvcBanner.Banner30 },
  { id: 31, videoId: "mY-0nUWHEtE", thumbnail: TvcBanner.Banner31 },
  { id: 32, videoId: "A0KRETCt9EU", thumbnail: TvcBanner.Banner32 },
  { id: 33, videoId: "-VhkdvjXlX8", thumbnail: TvcBanner.Banner33 },
  { id: 34, videoId: "pOJ6MB4twzA", thumbnail: TvcBanner.Banner34 },
  { id: 35, videoId: "zkbPnzjx2HM", thumbnail: TvcBanner.Banner35 },
  { id: 36, videoId: "d8RDys0kb7M", thumbnail: TvcBanner.Banner36 },
  { id: 37, videoId: "PWnQq1QQc0M", thumbnail: TvcBanner.Banner37 },
  { id: 38, videoId: "6G-LJRtu8wA", thumbnail: TvcBanner.Banner38 },
  { id: 39, videoId: "nmLWrN9pjwM", thumbnail: TvcBanner.Banner39 },
  { id: 40, videoId: "RZ3p_PYhVYw", thumbnail: TvcBanner.Banner40 },
  { id: 41, videoId: "0H4neocxmnA", thumbnail: TvcBanner.Banner41 },
  { id: 42, videoId: "ZNMSs5Gq9IY", thumbnail: TvcBanner.Banner42 },
  { id: 43, videoId: "3KqXd9DZCiM", thumbnail: TvcBanner.Banner43 },
  { id: 44, videoId: "hDxGIejuI2A", thumbnail: TvcBanner.Banner44 },
  { id: 45, videoId: "m7TqjUoeHt0", thumbnail: TvcBanner.Banner45 },
  { id: 46, videoId: "AWoMSqGHqbg", thumbnail: TvcBanner.Banner46 },
  { id: 47, videoId: "5EMeUbgQSvI", thumbnail: TvcBanner.Banner47 },
  { id: 48, videoId: "lzTdDlmBTfI", thumbnail: TvcBanner.Banner48 },
  { id: 49, videoId: "InLGLOj40MY", thumbnail: TvcBanner.Banner49 },
  { id: 50, videoId: "5sTudYQVK-A", thumbnail: TvcBanner.Banner50 },
  { id: 51, videoId: "sbHtZUZNRew", thumbnail: TvcBanner.Banner51 },
  { id: 52, videoId: "afCJkGy1ujY", thumbnail: TvcBanner.Banner52 },
  { id: 53, videoId: "5iLwU3M3e48", thumbnail: TvcBanner.Banner53 },
  { id: 54, videoId: "ZUVjDJJHwvU", thumbnail: TvcBanner.Banner54 },
  { id: 55, videoId: "quwU-sFOIxk", thumbnail: TvcBanner.Banner55 },
  { id: 56, videoId: "zUgVR7I8hQU", thumbnail: TvcBanner.Banner56 },
  { id: 57, videoId: "a2xGUZiUTEk", thumbnail: TvcBanner.Banner57 },
  { id: 58, videoId: "gAaLWyG3mIk", thumbnail: TvcBanner.Banner58 },
  { id: 59, videoId: "EPtTk16g5T4", thumbnail: TvcBanner.Banner59 },
  { id: 60, videoId: "lIsUuu0h2qs", thumbnail: TvcBanner.Banner60 },
  { id: 61, videoId: "BRTCGwvxRMU", thumbnail: TvcBanner.Banner61 },
  { id: 62, videoId: "KxLnZ0w4cEg", thumbnail: TvcBanner.Banner62 },
  { id: 63, videoId: "udqbC_yJKLs", thumbnail: TvcBanner.Banner63 },
  { id: 64, videoId: "R9DdKTVJijk", thumbnail: TvcBanner.Banner64 },
  { id: 65, videoId: "XUnGx1ltlRs", thumbnail: TvcBanner.Banner65 },
  { id: 66, videoId: "PAVAghxXNv0", thumbnail: TvcBanner.Banner66 },
  { id: 67, videoId: "fn6p8_93Nvo", thumbnail: TvcBanner.Banner67 },
  { id: 68, videoId: "P914x32tIhE", thumbnail: TvcBanner.Banner68 },
  { id: 69, videoId: "ZtDRsydmA0E", thumbnail: TvcBanner.Banner69 },
  { id: 70, videoId: "3wBK6x7iQxM", thumbnail: TvcBanner.Banner70 },
  { id: 71, videoId: "OIzOxroc0_0", thumbnail: TvcBanner.Banner71 },
  { id: 72, videoId: "WujjbU6N2rs", thumbnail: TvcBanner.Banner72 },
  { id: 73, videoId: "yvLgFNzKIBE", thumbnail: TvcBanner.Banner73 },
  { id: 74, videoId: "UDxa7AuUJ8w", thumbnail: TvcBanner.Banner74 },
  { id: 75, videoId: "LwcUYsYbY2E", thumbnail: TvcBanner.Banner75 },
  { id: 76, videoId: "Q2mjGsGNl-E", thumbnail: TvcBanner.Banner76 },
  { id: 77, videoId: "cZx8mE68Duw", thumbnail: TvcBanner.Banner77 },
  { id: 78, videoId: "I46pW7uXwUw", thumbnail: TvcBanner.Banner78 },
  { id: 79, videoId: "5AMyRFNBgZI", thumbnail: TvcBanner.Banner79 },
  { id: 80, videoId: "RTV2KwSmYjg", thumbnail: TvcBanner.Banner80 },
  { id: 81, videoId: "OY3KQMYnRsA", thumbnail: TvcBanner.Banner81 },
  { id: 82, videoId: "mDreZgQpJI8", thumbnail: TvcBanner.Banner82 },
  { id: 83, videoId: "h3d1mQox684", thumbnail: TvcBanner.Banner83 },
  { id: 84, videoId: "gYY_uUqUtcE", thumbnail: TvcBanner.Banner84 },
  { id: 85, videoId: "rpeS7yiodX0", thumbnail: TvcBanner.Banner85 },
  { id: 86, videoId: "QssKb9KtyYo", thumbnail: TvcBanner.Banner86 },
  { id: 87, videoId: "-BEsmy2ReQE", thumbnail: TvcBanner.Banner87 },
  { id: 88, videoId: "JOK4gOT37ts", thumbnail: TvcBanner.Banner88 },
  { id: 89, videoId: "YxLQCLm8fNk", thumbnail: TvcBanner.Banner89 },
  { id: 90, videoId: "lo59w4CG3Ws", thumbnail: TvcBanner.Banner90 },
  { id: 91, videoId: "CSBgdFrSZRQ", thumbnail: TvcBanner.Banner91 },
  { id: 92, videoId: "wrB0mvhdGr0", thumbnail: TvcBanner.Banner92 },
  { id: 93, videoId: "WGBBidS09Ws", thumbnail: TvcBanner.Banner93 },
  { id: 94, videoId: "nLYnpt-v31I", thumbnail: TvcBanner.Banner94 },
  { id: 95, videoId: "R_7k3ixzoi8", thumbnail: TvcBanner.Banner95 },
  { id: 96, videoId: "xBbnTXrDlas", thumbnail: TvcBanner.Banner96 },
  { id: 97, videoId: "CW_bApWqADc", thumbnail: TvcBanner.Banner97 },
  { id: 98, videoId: "Api2ppFaMMQ", thumbnail: TvcBanner.Banner98 },
  { id: 99, videoId: "aIqgMnkgtJg", thumbnail: TvcBanner.Banner99 },
  { id: 100, videoId: "EadSr4g1Bzs", thumbnail: TvcBanner.Banner100 },
  { id: 101, videoId: "SrAFRCbz3LA", thumbnail: TvcBanner.Banner101 },
  { id: 102, videoId: "v0ITP2oUL64", thumbnail: TvcBanner.Banner102 },
  { id: 103, videoId: "nMFKhlC7E9k", thumbnail: TvcBanner.Banner103 },
  { id: 104, videoId: "jxV8TSUo3Zs", thumbnail: TvcBanner.Banner104 },
  { id: 105, videoId: "wiet-v3Ey4Q", thumbnail: TvcBanner.Banner105 },
  { id: 106, videoId: "JB4cwOp1LjA", thumbnail: TvcBanner.Banner106 },
  { id: 107, videoId: "88-ZmtpOr04", thumbnail: TvcBanner.Banner107 },
  { id: 108, videoId: "bybt5Dyr2Ok", thumbnail: TvcBanner.Banner108 },
  { id: 109, videoId: "ll2Kw8ZCokY", thumbnail: TvcBanner.Banner109 },
  { id: 110, videoId: "1kYNFzy4Rl4", thumbnail: TvcBanner.Banner110 },
  { id: 111, videoId: "R8KmfEyuqjc", thumbnail: TvcBanner.Banner111 },
  { id: 112, videoId: "uNJNkbEthS8", thumbnail: TvcBanner.Banner112 },
  { id: 113, videoId: "l_znDDStdUA", thumbnail: TvcBanner.Banner113 },
  { id: 114, videoId: "sl4yEeueenY", thumbnail: TvcBanner.Banner114 },
];

export const tvcsVideos = [
  { id: 1, videoId: "AwL6yTUagzI", thumbnail: TvcBanner.Banner1 },
  { id: 2, videoId: "0qAWa1A7ofc", thumbnail: TvcBanner.Banner2 },
  { id: 3, videoId: "OclaX8TXVcQ", thumbnail: TvcBanner.Banner3 },
  { id: 4, videoId: "cp-cP9B1iWk", thumbnail: TvcBanner.Banner4 },
  { id: 5, videoId: "T3AtRfn-WJw", thumbnail: TvcBanner.Banner5 },
  // { id: 6, videoId: "L9NZLtfHB18", thumbnail: TvcBanner.Banner6 },
  { id: 6, videoId: "dlil1p3xOrc", thumbnail: TvcBanner.Banner6 },
  { id: 7, videoId: "xSffu54_bXQ", thumbnail: TvcBanner.Banner7 },
  { id: 8, videoId: "Rg_Ov9IDR5s", thumbnail: TvcBanner.Banner8 },
  { id: 9, videoId: "EX-6duRGRQk", thumbnail: TvcBanner.Banner9 },
  { id: 10, videoId: "UofYUxJxUMY", thumbnail: TvcBanner.Banner10 },
  { id: 11, videoId: "PlBeYwFOfU4", thumbnail: TvcBanner.Banner11 },
  { id: 12, videoId: "4y5UR9fAouQ", thumbnail: TvcBanner.Banner12 },
  { id: 13, videoId: "PNwpwl5vN0o", thumbnail: TvcBanner.Banner13 },
  { id: 14, videoId: "reNzcH9rPns", thumbnail: TvcBanner.Banner14 },
  { id: 15, videoId: "5dOTI9LG1T0", thumbnail: TvcBanner.Banner15 },
  { id: 16, videoId: "ecKXwq5Mik4", thumbnail: TvcBanner.Banner16 },
  { id: 17, videoId: "Qs0_Eg6qx8g", thumbnail: TvcBanner.Banner17 },
  { id: 18, videoId: "jGKwJV1ZIWs", thumbnail: TvcBanner.Banner18 },
  { id: 19, videoId: "0egglPxUFXE", thumbnail: TvcBanner.Banner19 },
  { id: 20, videoId: "3emrVSFlABY", thumbnail: TvcBanner.Banner20 },
  { id: 21, videoId: "Ik-7m-UfKRc", thumbnail: TvcBanner.Banner21 },
  { id: 22, videoId: "yHW7axdVhFk", thumbnail: TvcBanner.Banner22 },
  { id: 23, videoId: "i4eC0TQ6jLU", thumbnail: TvcBanner.Banner23 },
  // { id: 24, videoId: "dlil1p3xOrc", thumbnail: TvcBanner.Banner24 },
  { id: 24, videoId: "L9NZLtfHB18", thumbnail: TvcBanner.Banner24 },
  { id: 25, videoId: "cGdF6ao0Pso", thumbnail: TvcBanner.Banner25 },
  { id: 26, videoId: "h36hReRlqzU", thumbnail: TvcBanner.Banner26 },
  { id: 27, videoId: "TdrWlXvLhXo", thumbnail: TvcBanner.Banner27 },
  { id: 28, videoId: "o6c5AkWvge8", thumbnail: TvcBanner.Banner28 },
  { id: 29, videoId: "Z05C3YiR20s", thumbnail: TvcBanner.Banner29 },
  { id: 30, videoId: "BcfpoyjkZwo", thumbnail: TvcBanner.Banner30 },
  { id: 31, videoId: "BgSKH-aQAiU", thumbnail: TvcBanner.Banner31 },
  { id: 32, videoId: "qZ9tbwfejWg", thumbnail: TvcBanner.Banner32 },
  { id: 33, videoId: "IxuJWWfoZ7I", thumbnail: TvcBanner.Banner33 },
  { id: 34, videoId: "dQbSwtMSIcc", thumbnail: TvcBanner.Banner34 },
  { id: 35, videoId: "CHGng6slutY", thumbnail: TvcBanner.Banner35 },
  { id: 36, videoId: "RctSQI5WqzI", thumbnail: TvcBanner.Banner36 },
  { id: 37, videoId: "mY-0nUWHEtE", thumbnail: TvcBanner.Banner37 },
  { id: 38, videoId: "A0KRETCt9EU", thumbnail: TvcBanner.Banner38 },
  { id: 39, videoId: "-VhkdvjXlX8", thumbnail: TvcBanner.Banner39 },
  { id: 40, videoId: "pOJ6MB4twzA", thumbnail: TvcBanner.Banner40 },
  { id: 41, videoId: "zkbPnzjx2HM", thumbnail: TvcBanner.Banner41 },
  { id: 42, videoId: "d8RDys0kb7M", thumbnail: TvcBanner.Banner42 },
  { id: 43, videoId: "PWnQq1QQc0M", thumbnail: TvcBanner.Banner43 },
  { id: 44, videoId: "6G-LJRtu8wA", thumbnail: TvcBanner.Banner44 },
  { id: 45, videoId: "nmLWrN9pjwM", thumbnail: TvcBanner.Banner45 },
  { id: 46, videoId: "RZ3p_PYhVYw", thumbnail: TvcBanner.Banner46 },
  { id: 47, videoId: "0H4neocxmnA", thumbnail: TvcBanner.Banner47 },
  { id: 48, videoId: "ZNMSs5Gq9IY", thumbnail: TvcBanner.Banner48 },
  { id: 49, videoId: "3KqXd9DZCiM", thumbnail: TvcBanner.Banner49 },
  { id: 50, videoId: "hDxGIejuI2A", thumbnail: TvcBanner.Banner50 },
  { id: 51, videoId: "lzTdDlmBTfI", thumbnail: TvcBanner.Banner51 },
  { id: 52, videoId: "AWoMSqGHqbg", thumbnail: TvcBanner.Banner52 },
  { id: 53, videoId: "5EMeUbgQSvI", thumbnail: TvcBanner.Banner53 },
  { id: 54, videoId: "InLGLOj40MY", thumbnail: TvcBanner.Banner54 },
  { id: 55, videoId: "InLGLOj40MY", thumbnail: TvcBanner.Banner55 },
  { id: 56, videoId: "5sTudYQVK-A", thumbnail: TvcBanner.Banner56 },
  { id: 57, videoId: "sbHtZUZNRew", thumbnail: TvcBanner.Banner57 },
  { id: 58, videoId: "afCJkGy1ujY", thumbnail: TvcBanner.Banner58 },
  { id: 59, videoId: "5iLwU3M3e48", thumbnail: TvcBanner.Banner59 },
  { id: 60, videoId: "ZUVjDJJHwvU", thumbnail: TvcBanner.Banner60 },
  { id: 61, videoId: "quwU-sFOIxk", thumbnail: TvcBanner.Banner61 },
  { id: 62, videoId: "zUgVR7I8hQU", thumbnail: TvcBanner.Banner62 },
  { id: 63, videoId: "a2xGUZiUTEk", thumbnail: TvcBanner.Banner63 },
  { id: 64, videoId: "gAaLWyG3mIk", thumbnail: TvcBanner.Banner64 },
  { id: 65, videoId: "EPtTk16g5T4", thumbnail: TvcBanner.Banner65 },
  { id: 66, videoId: "lIsUuu0h2qs", thumbnail: TvcBanner.Banner66 },
  { id: 67, videoId: "BRTCGwvxRMU", thumbnail: TvcBanner.Banner67 },
  { id: 68, videoId: "KxLnZ0w4cEg", thumbnail: TvcBanner.Banner68 },
  { id: 69, videoId: "udqbC_yJKLs", thumbnail: TvcBanner.Banner69 },
  { id: 70, videoId: "R9DdKTVJijk", thumbnail: TvcBanner.Banner70 },
  { id: 71, videoId: "XUnGx1ltlRs", thumbnail: TvcBanner.Banner71 },
  { id: 72, videoId: "PAVAghxXNv0", thumbnail: TvcBanner.Banner72 },
  { id: 73, videoId: "fn6p8_93Nvo", thumbnail: TvcBanner.Banner73 },
  { id: 74, videoId: "P914x32tIhE", thumbnail: TvcBanner.Banner74 },
  { id: 75, videoId: "ZtDRsydmA0E", thumbnail: TvcBanner.Banner75 },
  { id: 76, videoId: "3wBK6x7iQxM", thumbnail: TvcBanner.Banner76 },
  { id: 77, videoId: "OIzOxroc0_0", thumbnail: TvcBanner.Banner77 },
  { id: 78, videoId: "WujjbU6N2rs", thumbnail: TvcBanner.Banner78 },
  { id: 79, videoId: "yvLgFNzKIBE", thumbnail: TvcBanner.Banner79 },
  { id: 80, videoId: "UDxa7AuUJ8w", thumbnail: TvcBanner.Banner80 },
  { id: 81, videoId: "LwcUYsYbY2E", thumbnail: TvcBanner.Banner81 },
  { id: 82, videoId: "Q2mjGsGNl-E", thumbnail: TvcBanner.Banner82 },
  { id: 83, videoId: "cZx8mE68Duw", thumbnail: TvcBanner.Banner83 },
  { id: 84, videoId: "I46pW7uXwUw", thumbnail: TvcBanner.Banner84 },
  { id: 85, videoId: "5AMyRFNBgZI", thumbnail: TvcBanner.Banner85 },
  { id: 86, videoId: "RTV2KwSmYjg", thumbnail: TvcBanner.Banner86 },
  { id: 87, videoId: "OY3KQMYnRsA", thumbnail: TvcBanner.Banner87 },
  { id: 88, videoId: "mDreZgQpJI8", thumbnail: TvcBanner.Banner88 },
  { id: 89, videoId: "h3d1mQox684", thumbnail: TvcBanner.Banner89 },
  { id: 90, videoId: "gYY_uUqUtcE", thumbnail: TvcBanner.Banner90 },
  { id: 91, videoId: "rpeS7yiodX0", thumbnail: TvcBanner.Banner91 },
  { id: 92, videoId: "QssKb9KtyYo", thumbnail: TvcBanner.Banner92 },
  { id: 93, videoId: "-BEsmy2ReQE", thumbnail: TvcBanner.Banner93 },
  { id: 94, videoId: "JOK4gOT37ts", thumbnail: TvcBanner.Banner94 },
  { id: 95, videoId: "YxLQCLm8fNk", thumbnail: TvcBanner.Banner95 },
  { id: 96, videoId: "lo59w4CG3Ws", thumbnail: TvcBanner.Banner96 },
  { id: 97, videoId: "CSBgdFrSZRQ", thumbnail: TvcBanner.Banner97 },
  { id: 98, videoId: "wrB0mvhdGr0", thumbnail: TvcBanner.Banner98 },
  { id: 99, videoId: "WGBBidS09Ws", thumbnail: TvcBanner.Banner99 },
  { id: 100, videoId: "nLYnpt-v31I", thumbnail: TvcBanner.Banner100 },
  { id: 101, videoId: "R_7k3ixzoi8", thumbnail: TvcBanner.Banner101 },
  { id: 102, videoId: "xBbnTXrDlas", thumbnail: TvcBanner.Banner102 },
  { id: 103, videoId: "CW_bApWqADc", thumbnail: TvcBanner.Banner103 },
  { id: 104, videoId: "Api2ppFaMMQ", thumbnail: TvcBanner.Banner104 },
  { id: 105, videoId: "aIqgMnkgtJg", thumbnail: TvcBanner.Banner105 },
  { id: 106, videoId: "EadSr4g1Bzs", thumbnail: TvcBanner.Banner106 },
  { id: 107, videoId: "SrAFRCbz3LA", thumbnail: TvcBanner.Banner107 },
  { id: 108, videoId: "v0ITP2oUL64", thumbnail: TvcBanner.Banner108 },
  { id: 109, videoId: "nMFKhlC7E9k", thumbnail: TvcBanner.Banner109 },
  { id: 110, videoId: "jxV8TSUo3Zs", thumbnail: TvcBanner.Banner110 },
  { id: 111, videoId: "wiet-v3Ey4Q", thumbnail: TvcBanner.Banner111 },
  { id: 112, videoId: "JB4cwOp1LjA", thumbnail: TvcBanner.Banner112 },
  { id: 113, videoId: "88-ZmtpOr04", thumbnail: TvcBanner.Banner113 },
  { id: 114, videoId: "bybt5Dyr2Ok", thumbnail: TvcBanner.Banner114 },
  { id: 115, videoId: "ll2Kw8ZCokY", thumbnail: TvcBanner.Banner115 },
  { id: 116, videoId: "1kYNFzy4Rl4", thumbnail: TvcBanner.Banner116 },
  { id: 117, videoId: "R8KmfEyuqjc", thumbnail: TvcBanner.Banner117 },
  { id: 118, videoId: "uNJNkbEthS8", thumbnail: TvcBanner.Banner118 },
  { id: 119, videoId: "l_znDDStdUA", thumbnail: TvcBanner.Banner119 },
  { id: 120, videoId: "sl4yEeueenY", thumbnail: TvcBanner.Banner120 },
];

export const longFormatData = [
  {
    name: "Karmma Calling",
    background: longFormatAssets.karmaCalling,
    // backgroundMb: longFormatAssets.karmaCallingMb,
    backgroundMb: longFormatAssets.karmaCalling1024x768,

    images: [
      {
        width: 2560,
        height: 1600,
        src: longFormatAssets?.karmaCalling2560x1600,
      },
      {
        width: 1600,
        src: longFormatAssets?.karmaCalling1600x1200,
      },
      {
        width: 1024,
        height: 1292,
        src: longFormatAssets?.karmaCalling1024x768,
      },
      {
        width: 992,
        src: longFormatAssets?.karmaCalling1024x768,
      },
      {
        width: 400,
        src: longFormatAssets?.karmaCalling1024x768,
      },
    ],
    type: "web show",
    year: 2024,
    seasons: 1,
    desc: "Karma Talwar seeks vengeance for her father's downfall, exposing corruption and betrayal in a gripping tale of justice and redemption.",
    videoId: "jNmb7LF0UOE",
    Starring: "Raveena Tandon, Varun Sood, Namrata Seth",
    Director: "Ruchi Narain",
  },
  {
    name: "Guilty",
    background: longFormatAssets.guilty,
    // backgroundMb: longFormatAssets.guiltyMb,
    backgroundMb: longFormatAssets.guilty1024x1292,
    images: [
      {
        width: 2560,
        height: 1600,
        src: longFormatAssets?.guilty2560x1600,
      },
      {
        width: 1600,
        src: longFormatAssets?.guilty1600x1200,
      },
      {
        width: 1024,
        height: 1292,
        src: longFormatAssets?.guilty1024x1292,
      },
      {
        width: 992,
        src: longFormatAssets?.guilty1024x1292,
      },
      {
        width: 400,
        src: longFormatAssets?.guilty1024x1292,
      },
    ],
    type: "film",
    year: 2020,
    desc: "When a college heartthrob is accused of rape, his girlfriend seeks the truth, navigating conflicting accounts and questioning her own beliefs.",
    videoId: "4xVmhHZtm18",
    Starring:
      "Kiara Advani, Taher Shabbir, Gurfateh Pirzada, Akanksha Ranjan Kapoor",
    Director: "Ruchi Narain",
  },
  {
    name: "The Hundred",
    background: longFormatAssets.hundred,
    backgroundMb: longFormatAssets.hundredMb,
    images: [
      {
        width: 2560,
        height: 1600,
        src: longFormatAssets?.hundred2560x1600,
      },
      {
        width: 1600,
        src: longFormatAssets?.hundred1600x1200,
      },
      {
        width: 1024,
        height: 1292,
        src: longFormatAssets?.hundred1024x1292,
      },
      {
        width: 992,
        src: longFormatAssets?.hundred1024x1292,
      },
      {
        width: 400,
        src: longFormatAssets?.hundredMb,
      },
    ],
    type: "web show",
    year: 2020,
    seasons: 1,
    desc: "Facing a terminal illness, Netra Patil joins ACP Saumya Shukla as an undercover agent, diving into this thrilling rollercoaster of a journey, filled with suspense and hilariously unexpected twists.",
    videoId: "gnnVsCJYgjE",
    Starring: "Lara Dutta, Rinku Rajguru, Makrand Deshpande",
    Director: "Ruchi Narain, Ashutosh Shah, Taher Shabbir",
  },
  {
    name: "Hanuman Da Damdaar",
    background: longFormatAssets.hanuman,
    backgroundMb: longFormatAssets.hanumanMb,
    images: [
      {
        width: 2560,
        height: 1600,
        src: longFormatAssets?.hanuman2560x1600,
      },
      {
        width: 1600,
        src: longFormatAssets?.hanuman1600x1200,
      },
      {
        width: 1024,
        height: 1292,
        src: longFormatAssets?.hanuman1024x1292,
      },
      {
        width: 992,
        src: longFormatAssets?.hanuman1024x1292,
      },
      {
        width: 400,
        src: longFormatAssets?.hanumanMb,
      },
    ],
    type: "web show",
    year: 2017,
    desc: "Young Maruti transforms into the mighty Hanuman Da' Damdaar, discovering courage in a vibrant, action-packed adventure filled with humor and heart.",
    videoId: "Hp_5OIBRouY",
    Starring:
      "Salman Khan, Saurabh Shukla, Raveena Tandon, Vinay Pathak, Kunal Khemu, Javed Akhtar",
    Director: "Ruchi Narain",
  },
  {
    name: "Kal: Yesterday and Tomorrow",
    background: longFormatAssets.kal,
    backgroundMb: longFormatAssets.kalMb,
    images: [
      {
        width: 2560,
        height: 1600,
        src: longFormatAssets?.kal2560x1600,
      },
      {
        width: 1600,
        src: longFormatAssets?.kal1600x1200,
      },
      {
        width: 1024,
        height: 1292,
        src: longFormatAssets?.kal1024x1292,
      },
      {
        width: 992,
        src: longFormatAssets?.kal1024x1292,
      },
      {
        width: 400,
        src: longFormatAssets?.kalMb,
      },
    ],
    type: "web show",
    year: 2005,
    desc: "Tarun marries Maya, breaking Bhavna's heart, but Maya is murdered after he reunites with Bhavna. If he was with Bhavna all night, who killed Maya?",
    videoId: "lCJtxnQcx-o",
    Starring: "Chitrangada Singh, Shiney Ahuja, Smriti Mishra, Ram Kapoor",
    Director: "Ruchi Narain",
  },
];

// export const shortsAndDocData = [
//   {
//     name: "Retrospective Film on BV Doshi",
//     background: shortsanddocAssets.BvDoshi,
//     year: "2014",
//     type: "Documentary",
//     desc: "This documentary explores the life and legacy of Balkrishna Vithaldas Doshi, India's first Pritzker-winning architect, highlighting his visionary, empathetic, and sustainable designs.",
//     videoId: "yZ-GpA-zhXU",
//     Director: "Ashutosh Shah, Taher Shabbir",
//   },
//   {
//     name: "Right Forward",
//     background: shortsanddocAssets.RightForward,
//     year: "2015",
//     type: "Documentary",
//     desc: "Right Forward is an inspiring documentary about young girls from Mumbai’s underserved communities who defy the odds through soccer. With support from NGO Magic Bus, they rise above adversity to represent India internationally, travelling to the U.S. to showcase their talent, forge connections, and prove that dreams have no boundaries.",
//     videoId: "T78b2yngHFw",
//     Director: "Ruchi Narain",
//   },
//   {
//     name: "Bitter Sweets",
//     background: shortsanddocAssets.BitterSweet,
//     year: "2022",
//     type: "Short Film",
//     desc: "Bittersweets is a heartfelt exploration of love and loss based on true events set in the ghettos of Bombay and delves into the intricate layers of human relationships, aspirations, and bitter realities that often accompany life's sweet moments. It holds the distinction of being the first film to be shot live on location in the vibrant and bustling streets of Bhendi Bazaar, adding an authentic layer of depth and charm to its visual storytelling. ",
//     videoId: "9U4o1ltJm2s",
//     Starring: "Pankaj Tripathi, Taher Shabbir",
//   },
//   {
//     name: "Shiksha Ka Suraj",
//     background: shortsanddocAssets.ShikshaKaSuraj,
//     year: "2012",
//     Director: "Ashutosh Shah & Taher Shabbir",
//     desc: "Shiksha Ka Suraj is a celebrity-led music video promoting adult literacy in India. With stars like Shah Rukh Khan and lyrics by Javed Akhtar, it encourages learning as a path to empowerment and was hailed as the “Mile Sur Mera Tumhara of the millennium.",
//     videoId: "w0TPgfZpqps",
//   },
//   {
//     name: "Skoda Prize Film",
//     background: shortsanddocAssets.SkodaPrize,
//     year: "2011",
//     desc: "A branded short film created for The Škoda Prize for Contemporary Art 2011, this piece celebrates emerging voices in Indian contemporary art and captures the spirit of the award and its vision.",
//     videoId: "MYPCfCmmTSc",
//     Director: "Ashutosh Shah & Taher Shabbir",
//   },
//   {
//     name: "The last Dance",
//     background: shortsanddocAssets.TheLastDance,
//     year: "2006",
//     desc: "Following the cruel reality of bear dancing in India, this documentary unveils the exploitation of sloth bears and the illegal trade that fuels it. Through undercover footage and moving rescues, it captures the fight to end this practice and restore dignity to a species long abused.",
//     videoId: "hUOIHKaC4nU",
//     Director: "Ashima Narain",
//   },
// ];

export const shortsAndDocData = [
  {
    name: "Retrospective Film on BV Doshi",
    background: shortsanddocAssets.BvDoshi,
    year: "2014",
    type: "Documentary",
    desc: "This film honours Pritzker Prize winner B.V. Doshi, tracing his journey from working with Le Corbusier to redefining Indian architecture through empathy, innovation, and landmark projects like CEPT and Aranya Housing.",
    videoId: "yZ-GpA-zhXU",
    Director: "Ashutosh Shah & Taher Shabbir",
  },
  {
    name: "Right Forward",
    background: shortsanddocAssets.RightForward,
    year: "2015",
    type: "Documentary",
    desc: "An uplifting documentary about girls from Mumbai's under-served communities who, through football and the NGO Magic Bus, rise above challenges to represent India in the U.S.—showing that dreams know no limits.",
    videoId: "T78b2yngHFw",
    Director: "Ruchi Narain",
  },
  {
    name: "Bitter Sweets",
    background: shortsanddocAssets.BitterSweet,
    year: "2022",
    type: "Short Film",
    desc: "Based on true events, this film is an exploration of love & loss in the ghettos of Bombay. Shot entirely in Bhendi Bazaar, it brings raw emotion and authenticity to its layered storytelling.",
    videoId: "9U4o1ltJm2s",
    Starring: "Pankaj Tripathi, Taher Shabbir",
    Director: "Ashutosh Shah & Taher Shabbir",
  },
  {
    name: "Shiksha Ka Suraj",
    background: shortsanddocAssets.ShikshaKaSuraj,
    year: "2012",
    desc: "A star-led music video promoting adult literacy, featuring Shah Rukh Khan and lyrics by Javed Akhtar. Dubbed the “Mile Sur Mera Tumhara of the millennium,” it champions education as empowerment.",
    videoId: "w0TPgfZpqps",
    Director: "Ashutosh Shah & Taher Shabbir",
  },
  {
    name: "Škoda Prize Film",
    background: shortsanddocAssets.SkodaPrize,
    year: "2011",
    desc: "A branded short for The Škoda Prize for Contemporary Art 2011, this film celebrates emerging Indian artists and encapsulates the spirit and vision of the prestigious award.",
    videoId: "MYPCfCmmTSc",
    Director: "Ashutosh Shah & Taher Shabbir",
  },
  {
    name: "The last Dance",
    background: shortsanddocAssets.TheLastDance,
    year: "2006",
    desc: "This Film follows the cruel reality of bear dancing in India, revealing the exploitation of sloth bears and the illegal trade behind it. Through undercover footage and rescues, it highlights the mission to end this cruelty and restore dignity to the species.",
    videoId: "hUOIHKaC4nU",
    Director: "Ashima Narain",
  },
];
